import CryptoJS from "crypto-js";

export const validateData = (data, expectedHash) => {
  console.log("^^validateData : ", data, "#", expectedHash);
  const utf8Data = CryptoJS.enc.Utf8.parse(data); // UTF-8로 변환
  const hash = CryptoJS.SHA256(utf8Data).toString(CryptoJS.enc.Base64);
  const r = hash === expectedHash;
  return r;
};
